import React, { useEffect, useState } from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import axios from 'axios';
import { Row, Col, Button, Form, Modal, TreeSelect } from './../../ui/ot'

const { confirm } = Modal;
const DepartmentRole = ({
    field,
    remove,//不送就不會出現remove按鈕
    defaultDepartment,
    defaultRole,
    showMode,    //可供呈現一個結構體
    showLabel = false,//form的標籤
    onDepartmentRoleChange = () => { },
    departmentPlaceholder = "選擇部門",
    propsDepartmentClassifyStructureTypeId,
}) => {

    const [departmentData, setDepartmentData] = useState([]);
    const [roleData, setRoleData] = useState([]);
    const [departmentOption, setDepartmentOption] = useState([]);
    const [roleOption, setRoleOption] = useState([]);
    const [departmentId, setDepartmentId] = useState(defaultDepartment);
    const [roleId, setRoleId] = useState(defaultRole);
    const getDepartmentData = () => {
        axios
            .get('/organization_structure/api/department', {
                params: {
                    classify_structure_type_id: propsDepartmentClassifyStructureTypeId ?? 0,
                    classify_structure_id: 9
                }
            })
            .then((response) => {
                setDepartmentData(response.data.data)
            })
    }
    const getDepartmentOption = () => {
        axios
            .get('/organization_structure/api/department', {
                params: {
                }
            })
            .then((response) => {
                setDepartmentOption(response.data.data)
            })
    }
    const getRoleOption = () => {
        axios
            .get('/organization_structure/api/role', {
                params: {
                }
            })
            .then((response) => {
                setRoleOption(response.data.data)
            })
    }
    const getRoleData = () => {
        axios
            .get('/organization_structure/api/role', {
                params: {
                    // classify_structure_type_id_for_department: departmentId,
                    classify_structure_type_id: 0,
                    classify_structure_id: 8
                }
            })
            .then((response) => {
                setRoleData(response.data.data)
            })
    }
    const changeDepartmentRole = (departmentRoleDataTemp) => {
        let departmentRoleDataResult = []
        // setDepartmentRoleData(
        departmentRoleDataResult = departmentRoleDataTemp.map((item, index) => {
            let departmentId = 0
            let roleId = 0
            departmentOption.map((departmentDataItem, i) => {
                if (departmentDataItem.classify_structure_type_id === item.department_classify_structure_type_id) {
                    departmentId = departmentDataItem.department_id
                }
            })
            roleOption.map((roleDataItem, ii) => {
                if (roleDataItem.classify_structure_type_id === item.role_classify_structure_type_id) {
                    roleId = roleDataItem.role_id
                }
            })
            return (
                {
                    department_id: departmentId,
                    role_id: roleId
                }
            )
        })
        return departmentRoleDataResult;
    }
    useEffect(() => {
        getDepartmentData()
        getDepartmentOption()
        getRoleOption()
        getRoleData()
    }, []);
    useEffect(() => {
        if (departmentData.length !== 0 && defaultDepartment) {
            setDepartmentId(defaultDepartment)
        }
    }, [departmentData]);
    useEffect(() => {
        if (roleData.length !== 0 && defaultRole) {
            setRoleId(defaultRole)
        }
    }, [roleData]);

    useEffect(() => {
        let departmentRoleData = []
        if (departmentId | roleId) {
            departmentRoleData = changeDepartmentRole([
                {
                    department_classify_structure_type_id: departmentId,
                    role_classify_structure_type_id: roleId
                }
            ])
            onDepartmentRoleChange(departmentRoleData)
        }
    }, [departmentId, roleId])

    useEffect(() => {
        let departmentRoleData = []
        if (departmentId | roleId) {
            departmentRoleData = changeDepartmentRole([
                {
                    department_classify_structure_type_id: departmentId,
                    role_classify_structure_type_id: roleId
                }
            ])
            onDepartmentRoleChange(departmentRoleData)
        }
    }, [departmentId, roleId])

    useEffect(() => {
        let departmentRoleData = []
        if (departmentId | roleId) {
            departmentRoleData = changeDepartmentRole([
                {
                    department_classify_structure_type_id: departmentId,
                    role_classify_structure_type_id: roleId
                }
            ])
            onDepartmentRoleChange(departmentRoleData)
        }
    }, [departmentId, roleId])

    return (

        <Row gutter={[4, 4]} style={{ display: 'flex', justify: 'center', alignItems: 'center' }}>

            <Col span={remove !== undefined ? 20 : 24}>
                {departmentData.length !== 0 && (showMode === undefined || showMode === 'department') && <>
                    <Form.Item
                        label={"讀者類型"}
                        // label={showLabel ? "部門" : undefined}
                        name={[field.name, 'department_classify_structure_type_id']}
                        rules={[
                            {
                                required: true,
                                message: `此為必填項目`
                            }
                        ]}
                    >
                        <TreeSelect
                            // defaultValue={
                            //     departmentId
                            // }
                            showSearch
                            style={{
                                width: '100%',
                            }}
                            // value={value}
                            dropdownStyle={{
                                maxHeight: 400,
                                overflow: 'auto',
                            }}
                            placeholder="選擇讀者類型"
                            // placeholder={departmentPlaceholder}
                            allowClear
                            treeDefaultExpandAll
                            treeNodeFilterProp={"title"}
                            onChange={
                                (e) => {
                                    setDepartmentId(e.target.value)
                                }
                            }
                            treeData={departmentData}
                        />
                    </Form.Item>
                </>}
                {roleData.length !== 0 && (showMode === undefined || showMode === 'role') && <Form.Item

                    label={showLabel ? "職稱" : undefined}
                    name={[field.name, 'role_classify_structure_type_id']}
                    rules={[
                        {
                            required: true,
                            message: `此為必填項目`
                        }
                    ]}
                >
                    <TreeSelect
                        // defaultValue={
                        //     roleId
                        // }
                        showSearch
                        style={{
                            width: '100%',
                        }}
                        dropdownStyle={{
                            maxHeight: 400,
                            overflow: 'auto',
                        }}
                        placeholder="選擇職稱"
                        allowClear
                        treeDefaultExpandAll
                        treeNodeFilterProp={"title"}
                        onChange={
                            (e) => setRoleId(e.target.value)
                        }
                        treeData={roleData}
                    />
                </Form.Item>
                }
            </Col>
            <Col span={remove !== undefined ? 4 : 0}>
                <Button
                    onClick={() => {
                        confirm({
                            title: '確定要刪除嗎',
                            icon: <ExclamationCircleOutlined />,
                            okText: '確定',
                            okType: 'danger',
                            cancelText: '取消',
                            onOk() {
                                remove(field.name);
                            },
                            centered: true
                        });
                    }}> 刪除
                </Button>
            </Col>
        </Row>

    )
}
export default DepartmentRole;

